import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { FeedbackMessagesEffects } from './+state/feedback-messages.effects';

@NgModule({
  imports: [CommonModule, EffectsModule.forFeature([FeedbackMessagesEffects])],
})
export class MessagesDataAccessModule {}
